export const BILLS_ROUTES = {
    CREATE: "/{service_company_slug}/bills/create/",
    LIST: "/{service_company_slug}/bills/",
    COUNT: "/{service_company_slug}/api/bills/count/",
    LIGHTWEIGHT_LIST: "/{service_company_slug}/api/bills/lightweight/",
    UPDATE: "/{service_company_slug}/bills/{id}/update/",
    DETAILS: "/{service_company_slug}/bills/{id}/",
}
